'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ButtonMenuListPanel = require('./ButtonMenuListPanel');
var _ButtonMenuListPanel2 = _interopRequireDefault(_ButtonMenuListPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ButtonMenuBase = function (_React$Component) {
  _inherits(ButtonMenuBase, _React$Component);
  function ButtonMenuBase(props) {
    _classCallCheck(this, ButtonMenuBase);
    var _this = _possibleConstructorReturn(this, (ButtonMenuBase.__proto__ || Object.getPrototypeOf(ButtonMenuBase)).call(this, props));
    _this.state = {
      isMenuShown: false
    };
    _this.setButtonMenuRef = function (element) {
      _this.buttonMenuRef = element;
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleSelection = _this.handleSelection.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    return _this;
  }
  _createClass(ButtonMenuBase, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
      }
      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
      }
      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          children = _props.children,
          className = _props.className;
        return _react2['default'].createElement('div', {
          className: className,
          onClick: this.handleClick,
          ref: this.setButtonMenuRef
        }, children, this.renderMenu());
      }
      return render;
    }()
  }, {
    key: 'renderMenu',
    value: function () {
      function renderMenu() {
        if (this.state.isMenuShown) {
          var menuItems = this.props.menuItems;
          return _react2['default'].createElement(_ButtonMenuListPanel2['default'], {
            data: menuItems,
            disabledPropName: 'disabled',
            height: '260px',
            parentName: 'ButtonMenu',
            selectionConfirmedHandler: this.handleSelection,
            textPropName: 'name',
            valuePropName: 'value',
            width: '160px'
          });
        }
        return null;
      }
      return renderMenu;
    }()
  }, {
    key: 'handleDocumentClick',
    value: function () {
      function handleDocumentClick(e) {
        if (this.state.isMenuShown && this.buttonMenuRef && this.buttonMenuRef.contains(e.target) === false) {
          this.setState({
            isMenuShown: false
          });
        }
      }
      return handleDocumentClick;
    }()
  }, {
    key: 'handleClick',
    value: function () {
      function handleClick(e) {
        if (this.props.disabled) {
          e.preventDefault();
        } else {
          this.setState({
            isMenuShown: !this.state.isMenuShown
          });
        }
      }
      return handleClick;
    }()
  }, {
    key: 'handleSelection',
    value: function () {
      function handleSelection(selectedValue) {
        var firstSelectedValue = Array.isArray(selectedValue) && selectedValue.length > 0 ? selectedValue[0] : null;
        this.props.selectionHandler(firstSelectedValue);
      }
      return handleSelection;
    }()
  }]);
  return ButtonMenuBase;
}(_react2['default'].Component);
ButtonMenuBase.defaultProps = {
  disabled: false,
  menuItems: [],
  selectionHandler: function () {
    function selectionHandler() {}
    return selectionHandler;
  }()
};
ButtonMenuBase.propTypes = {
  /**
   * When set to true disables the component, changes it look and the click handler
   * is disabled. Default is false.
   */
  disabled: _propTypes2['default'].bool,
  /**
   * An array of objects bound to the list of items in the menu.
   * Format:
   * [
   *      { name: 'Aston Martin', value: 1 },
   *      { name: 'Ferrari', value: 2 },
   *      { name: 'Jaguar', value: 3 },
   *      { name: 'Land Rover', value: 4, disabled: true }
   * ]
   * The text prop name in this case has to be 'name'.
   * The value prop name in this case has to be 'value'.
   * You can also pass a disabled attribute through this list to disable certain options.
   */
  menuItems: _propTypes2['default'].array,
  /**
   * This function is called when the user selects an item from the menu.
   */
  selectionHandler: _propTypes2['default'].func
};
ButtonMenuBase.displayName = 'ButtonMenu';
exports['default'] = ButtonMenuBase;